/**
 * TODO : Load / Save from locaStorage or cookies
 */
 fx.ns("models", class Settings extends fx.Model {

    constructor(data)
    {
        super(data);
    }

    toggleGridMode()
    {
        this.gridmode = !this.gridmode; 
        this.event("grid-notification", {gridmode: this.gridmode});
    }

    get defaults()
    {
        return {
            precision : 5, 
            tolerance : 2, 
            gridmode : true,
            warningShowDelay : 3000,
            minDensity : 30, // DPI
            maxHistoryActionsStored : 50,
            numberOfSavings : 5,
            maxUploads : 5,
            maxAIProcesses : 3,
            noRevokePictures : 1000,
            coverTimeOut : 10000,
            coverImageTimeOut : 5000,
            socialFileSize : 1000,
            numMaxPhoto : 4,
            delayProposeRegister : 300000
        }
    }
}); 